module.exports = __webpack_public_path__ + "static/icons/icon-mountain-logo-round-5b115abe6c43b5c2c70dace01bd21845.svg";